import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Welcome from "./pages/Welcome";
import Audit from "./pages/Audit";
import AuditSignup from "./pages/AuditSignup";
import ClientLogin from "./pages/ClientLogin";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Results from "./pages/Results";
import WeeklyCheckin from "./pages/WeeklyCheckin";
import Coach from "./pages/Coach";
import CoachClient from "./pages/CoachClient";
import CoachDetail from "./pages/CoachDetail";
import CoachLogin from "./pages/CoachLogin";
import Footer from "./components/Footer";
import CoachTracker from "./pages/CoachTracker";
import { AuthCallback, ProtectedRoute } from "./lib/auth.jsx";
import { ClientAuthProvider, RequireClient } from "./lib/clientAuthContext.jsx";

function AppRoutes() {
  const location = useLocation();
  // Catch the OAuth callback hash even if the user landed on a different route.
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Welcome />} />

      {/* Client account flow (public) */}
      <Route path="/audit/signup" element={<AuditSignup />} />
      <Route path="/audit/login" element={<ClientLogin />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Roadmap questionnaire now requires a signed-in client */}
      <Route path="/audit" element={<RequireClient><Audit /></RequireClient>} />

      {/* Weekly Check-In (Stage 2B) — public route; page renders its own sign-in when unauthenticated */}
      <Route path="/weeklycheckin" element={<WeeklyCheckin />} />

      {/* Results stays public (accessed by URL) */}
      <Route path="/results/:id" element={<Results />} />

      {/* Coach (unchanged) */}
      <Route path="/coach-login" element={<CoachLogin />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/coach" element={<ProtectedRoute><Coach /></ProtectedRoute>} />
      <Route path="/coach/tracker" element={<ProtectedRoute><CoachTracker /></ProtectedRoute>} />
      <Route path="/coach/clients/:client_id" element={<ProtectedRoute><CoachClient /></ProtectedRoute>} />
      <Route path="/coach/:id" element={<ProtectedRoute><CoachDetail /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <ClientAuthProvider>
          <div className="flex-1">
            <AppRoutes />
          </div>
          <Footer />
        </ClientAuthProvider>
      </BrowserRouter>
    </div>
  );
}
